import { View } from "../../Core";
import Vue from "vue";
import { Uri } from "../../Core/Helpers/Uri";
import * as ajax from "@brightspark/sparkling-ajax-js";
import TimetableFilters from "../../Components/TimetableFilters/TimetableFilters.vue";
import XelectComponent from "../../Components/Xelect/XelectComponent.vue";

enum Action {
    GetTimetableFilters,
    GetTimetableItems,
}

interface ISelectListItem {
    text: string,
    value: string,
}

interface IFilters {
    groupLevels: Array<ISelectListItem>;
    groupTypes: Array<ISelectListItem>;
    trainers: Array<ISelectListItem>;
    locations: Array<ISelectListItem>;
}

interface IDefaultSchedule {
    daysOfWeek: Array<string>;
    startTime: string;
    endTime: string;
}

interface ITrainingGroup {
    id: string;
    name: string;
    code: string;
    periodStart: string;
    periodEnd: string;
    poolName: string;
    address: string;
    freePlaces: number;
    waitlistMemberCount: number;
    trainersFullNames: Array<string>;
    defaultSchedules: Array<IDefaultSchedule>;
    defaultPriceMo: number;
    registrationAvailable: boolean;
    registrationUrl: string;
}

interface IData {
    showGroupLevelsWith: Array<string>;
    groupLevels: Array<ISelectListItem>;
    groupTypes: Array<ISelectListItem>;
    trainers: Array<ISelectListItem>;
    locations: Array<ISelectListItem>;
    trainingGroups: Array<ITrainingGroup>;
    groupType: string;
    groupLevel: string;
    trainer: string;
    location: string;
    isTableItemsLoading: boolean;
}

class ViewDataModel {
    public showGroupLevelsWith: Array<string> = [];

    public groupType: string = "";
    public groupLevel: string = "";
    public trainer: string = "";
    public location: string = "";
    public rid: string;
}

export class TimeTableView extends View<TimeTableView> {
    private _viewData: ViewDataModel = window.__VIEW_DATA;

    public constructor() {
        super();
        this.SetupVue();
    }

    SetupVue() {
        const v = new Vue({
            el: ".timetable-filters",
            data: {
                showGroupLevelsWith: this._viewData.showGroupLevelsWith as Array<string>,
                groupLevels: new Array<ISelectListItem>(),
                groupTypes: new Array<ISelectListItem>(),
                trainers: new Array<ISelectListItem>(),
                locations: new Array<ISelectListItem>(),
                trainingGroups: new Array<ITrainingGroup>(),
                groupType: this._viewData.groupType,
                groupLevel: this._viewData.groupLevel,
                trainer: this._viewData.trainer,
                location: this._viewData.location,
                isTableItemsLoading: false,
                rid: this._viewData.rid,
            },
            mounted() {
                this.filterChange();
            },
            components: {
                TimetableFilters,
                XelectComponent
            },
            computed: {
                shouldShowGroupLevels() {
                    if (this.rid) {
                        return true;
                    }

                    var vue = this as any;
                    var index = vue.showGroupLevelsWith.indexOf(vue.groupType.toLowerCase());
                    return index > -1;
                },
                isTableEmpty() {
                    let vue = this as any;
                    return !vue.trainingGroups.length && !vue.isTableItemsLoading;
                }
            },
            methods: {
                shouldShowExactNumber(trainingGroup: ITrainingGroup) {
                    return trainingGroup.freePlaces <= 5;
                },
                getFreePlaceText(trainingGroup: ITrainingGroup) {
                    return this.shouldShowExactNumber(trainingGroup)
                        ? trainingGroup.freePlaces === 1 ? "koht jäänud!" : "viimast kohta!"
                        : "kohta veel vaba!";
                },
                getWaitlistMemberText(trainingGroup: ITrainingGroup) {
                    return trainingGroup.waitlistMemberCount > 1 || trainingGroup.waitlistMemberCount === 0
                        ? "inimest ootel"
                        : "inimene ootel";
                },
                filterChange() {
                    let vue = this as any;
                    ajax(Uri.getUri(Action[Action.GetTimetableFilters]), { dataType: "json", method: "post", data: vue.getSelectedFilters() })
                        .done((res: IFilters) => {
                            if (!res) {
                                return;
                            }

                            vue.locations = res.locations;
                            vue.groupLevels = res.groupLevels;
                            vue.groupTypes = res.groupTypes;
                            vue.trainers = res.trainers;

                        });

                    vue.getTimeTableItems();
                },
                getTimeTableItems() {
                    let vue = this as any;
                    vue.isTableItemsLoading = true;
                    ajax(Uri.getUri(Action[Action.GetTimetableItems]), { dataType: "json", method: "post", data: vue.getSelectedFilters() })
                        .done((res: Array<ITrainingGroup>) => {
                            if (!res) {
                                return;
                            }
                            vue.trainingGroups = res;

                            for (var i of res) {
                                if (vue.rid) {
                                    i.registrationUrl += "?rid=" + vue.rid;
                                }
                            }
                        })
                        .always(() => {
                            vue.isTableItemsLoading = false;
                        });
                },
                getSelectedFilters() {
                    return {
                        groupLevel: this.groupLevel,
                        groupTypeId: this.groupType,
                        trainerId: this.trainer,
                        locationId: this.location
                    } as any;
                },
                valueChanged(value, component) {
                    var name = component.name;
                    var vue = this as any;
                    if (vue[name] === value) {
                        return;
                    }

                    switch (name) {
                    case "LocationId":
                        vue.location = value;
                        break;
                    case "TrainerId":
                        vue.trainer = value;
                        break;
                    case "GroupTypeId":
                        vue.groupType = value;
                        break;
                    case "GroupLevel":
                        vue.groupLevel = value;
                        break;
                    default:
                        return;
                    }

                    vue.filterChange();
                },
            }
        });
    }
}


// WEBPACK FOOTER //
// ./www/js/Pages/TrainingGroup/TimeTableView.ts